import styled from "styled-components";

export const PromoHeaderContainer = styled.div`
  position: relative;
  background-image: ${({ url }) => `url("${url}")`};
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 0px 0px 4px 4px;
  height: 250px;
  width: 100%;
  @media only screen and (min-width: 320px) and (max-width: 545px) {
    border-radius: 0px 0px 4px 4px;
    height: 188px;
    width: 100%;
  }
  @media only screen and (min-width: 768px) and (max-width: 1023px) {
    width: 90vw;
  }
    
`;
export const StyledTitleLockupWrapper = styled.div`
  left: 24px;
  position: absolute;
  top: 24px;
  bottom:24px;
  width: 425px;
  @media only screen and (min-width: 320px) and (max-width: 545px) {
    left: 20px;
    top: 20px;
    width:90%;
    bottom:20px;
  }
  @media only screen and (min-width: 320px) and (max-width: 545px) and (max-height:933px){
    h2 {
      width:80%;
    }
  }
  @media only screen and (min-width: 640px) and (max-width: 800px) and (min-width: 360px) and (max-height:430px){
    h2 {
      width:74%;
    }
  }
  @media only screen and (min-width:1024px){
    h2{
      font-size:1.25rem;
    }
  }

  @media only screen and (min-width: 800px) and (max-width: 933px) and (min-width: 360px) and (max-height:430px){
    h2 {
      width:74%;
      font-size: 1.6rem;
    }
    h3 {
      width:74%;
      font-size: 1rem;
    }
  }
  
  @media only screen and (min-width: 800px) and (max-width: 933px) and (min-height: 360px) and (max-height:430px){
    h2 {
      width:74%;
      font-size: 1.6rem;
    }
    h3 {
      width:74%;
      font-size: 1rem;
    }
  }
  @media only screen and (min-width: 768px) and (max-width: 1024px) and (max-height:1368px){
    h2 {
      width:74%;
      font-size: 1.6rem;
    }
    h3 {
      width:74%;
      font-size: 1rem;
      line-height: 1.25rem;
    }
  }
  @media only screen and (min-width: 768px) and (max-width: 1024px) and (max-height:768px){
    h2 {
      width:74%;
      font-size: 1.3rem;
    }
    h3 {
      width:74%;
      font-size: 1rem;
    }
  }

  @media only screen and (min-width: 280px) and (max-width: 290px) and (max-height:654px){
    h2 {
      width:40%;
      font-size: 1.8rem;
    }
    h3 {
      width:74%;
      font-size: 0.7rem;
    }
  }
`;
